import "./index.css";
import { createReactScaffold } from "create-react-scaffold";
import { configure } from "mobx";
import { gstate, initCommon } from "./gstate";
import localforage from "localforage";
import { App } from "./App";
import { ensureSessionExists, isLogin } from "./auth";

(async () => {
  // 基本配置
  localforage.config({
    name: "KP.C.C.",
    storeName: "admin.ciya.club",
  });
  configure({
    useProxies: "ifavailable",
    enforceActions: "never",
  });

  await ensureSessionExists();

  // 入口登录相关判断逻辑
  const initPath = gstate.pathname;
  if (initPath !== "login") {
    const hasLogin = await isLogin();
    if (!hasLogin) {
      // const currentUrl = encodeURIComponent(window.location.href);
      window.location.href = "/login"; // ?redirect=+ currentUrl;
      return;
    }
  }

  // 已登录或正好是登录页面，直接加载
  await createReactScaffold({
    entry: "home",
    baseUrl: "",
    onStart() {
      initCommon();
    },
    onBeforePage() {
      gstate.loading = true;
      gstate.loadingTip = "页面加载中...";
    },
    onPage(content) {
      gstate.loading = false;
      gstate.loadingTip = undefined;
      return <App>{content}</App>;
    },
  });
})();
